import Component from '@bythepixel/component-loader';
import Map from './map';

export default class largeMap extends Component {
  static selector = '[data-comp-map]'
  #map

  constructor(mapEl) {
    super(mapEl);
    this.#map = new Map(this.$container);
  }

  addMarker(data) {
    return this.#map.addMarker(data);
  }

  addInfoWindow(data) {
    return this.#map.addInfoWindow(data);
  }

  setCenter(lat, lng) {
    this.#map.setCenter(lat, lng);
  }

  fitBounds() {
    this.#map.fitBounds();
  }

  getBounds() {
    return this.#map.getBounds();
  }

  flyTo(lat, lng) {
    this.#map.flyTo({
      center: [lat, lng],
      padding: 100,
      zoom: 12,
    });
  }

  get() {
    return this.#map.get();
  }

  on(event, cb) {
    this.#map.on(event, cb);
  }
}
